import { FiPlus } from "react-icons/fi";
import { useState, useEffect, useCallback } from "react";
import { Menu, MenuButton } from "@headlessui/react";
import { GoDotFill } from "react-icons/go";
import { IoCloseOutline } from "react-icons/io5";
import StatisticModel from "../model/StatisticModel";
import DeleteModel from "../model/DeleteModel";
import AddPeopleModel from "../model/AddPeopleModel";
import { MdOutlineGraphicEq } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ApiGet } from "../../helper/axiosFunctions";
import { commonToast } from "../../helper/Toast";
import PeopleSkeleton from "../skeleton/PeopleSkeleton";

export default function People() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isaddpeople, setisAddPeople] = useState(false);
  const [activeTab, setActiveTab] = useState(t("all"));
  const [isStatistic, setisStatistic] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [peopleList, setPeopleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [hide, sethide] = useState(() => {
    const savedHide = localStorage.getItem('people_helper_hidden');
    return savedHide ? JSON.parse(savedHide) : false;
  });
  const toggleHide = () => {
    const newHideState = !hide;
    sethide(newHideState);
    localStorage.setItem('people_helper_hidden', JSON.stringify(newHideState));
  };
  const classId = pathname?.split('/')[2];
  console.log('peopleList :>> ', peopleList);
  const fetchPeople = useCallback(async (tab) => {
    setLoading(true);
    try {
      if (tab === t("teacher")) {
        const response = await ApiGet(`/contents/classes/${classId}/teachers`);
        setPeopleList(response?.data?.map(teacher => ({
          ...teacher,
          role: 'teacher',
          teacherId: teacher.teacherId,
          firstName: teacher.firstName,
          lastName: teacher.lastName,
          img: teacher.avatarUrl
        })) || []);
      } else if (tab === t("student")) {
        const response = await ApiGet(`/contents/classes/${classId}/students`);
        setPeopleList(response?.data?.map(student => ({
          ...student,
          role: 'student',
          studentId: student.studentId,
          firstName: student.firstName,
          lastName: student.lastName,
          img: student.avatarUrl
        })) || []);
      } else {
        // For "all" tab, fetch both teachers and students
        const [teachersResponse, studentsResponse] = await Promise.all([
          ApiGet(`/contents/classes/${classId}/teachers`),
          ApiGet(`/contents/classes/${classId}/students`)
        ]);

        // Combine and transform the data
        const combinedData = [
          ...(teachersResponse?.data || []).map(teacher => ({
            ...teacher,
            role: 'teacher',
            teacherId: teacher.teacherId,
            firstName: teacher.firstName,
            lastName: teacher.lastName,
            img: teacher.avatarUrl
          })),
          ...(studentsResponse?.data || []).map(student => ({
            ...student,
            role: 'student',
            studentId: student.studentId,
            firstName: student.firstName,
            lastName: student.lastName,
            img: student.avatarUrl
          }))
        ];

        setPeopleList(combinedData);
      }
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.data?.error || error?.message, "error");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleDeleteClick = (person) => {
    setSelectedPerson(person);
    setIsDelete(true);
  };

  const handleDeleteSuccess = () => {
    fetchPeople(activeTab);
  };

  useEffect(() => {
    fetchPeople(activeTab);
  }, [activeTab, classId, fetchPeople]);

  const getRoleChip = (role) => {
    if (role === 'student') {
      return (
        <>
          <span className="text-xs w-fit bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
            {t("student")}
          </span>
          <GoDotFill fontSize={14} className="text-[10px]" />
          <h6 className="text-center"> {role?.subject || "N/A"}</h6>
        </>
      );
    } else if (role === 'teacher') {
      return (
        <>
          <span className="text-xs w-fit bg-green-100 text-green-800 px-2 py-1 rounded-full">
            {t("teacher")}
          </span>
          <GoDotFill fontSize={14} className="text-[10px]" />
          <h6 className="text-center"> {role?.school || "N/A"}</h6>
        </>
      );
    }
    return null;
  };

  const NoDataMessage = () => (
    <div className="text-center py-8">
      <p className="text-lg text-gray-500">
        {activeTab === t("teacher")
          ? t("No teachers found")
          : activeTab === t("student")
            ? t("No students found")
            : t("No data found")}
      </p>
    </div>
  );

  return (
    <div className={`flex lg:flex-col  ${hide ? 'justify-start' : 'justify-center'}  items-start gap-10`}>
      <div className={`max-w-5xl ${hide ? 'w-full' : 'w-[880px]'} lg:w-full`}>
        <div className={`bg-white p-5 rounded-3xl`}>
          <div className="flex sm:flex-col justify-between items-center">
            <div className="flex items-center md:text-center gap-3 border rounded-xl px-2 py-2">
              {[t("all"), `${t("teacher")}`, `${t("student")}`]?.map(
                (item) => (
                  <div
                    key={item}
                    onClick={() => setActiveTab(item)}
                    className={`cursor-pointer ${item === activeTab &&
                      "bg-darkblue text-white rounded-lg px-3 py-1"
                      } px-3`}
                  >
                    {item}
                  </div>
                )
              )}
            </div>

            <div className="flex items-center gap-3 sm:mt-3">
              <Menu>
                <MenuButton
                  onClick={() => setisAddPeople(true)}
                  className="inline-flex items-center gap-2 rounded-md  py-1.5 px-3 text-sm/6 font-semibold   focus:outline-none data-[open]:rounded-full  data-[open]:bg-[#F2F3FF] data-[focus]:outline-1 "
                >
                  <span className="regular-text">{t("add")}</span>
                  <FiPlus
                    fontSize={20}
                    className={`border rounded-full size-8 p-1 flex justify-center items-center`}
                  />
                </MenuButton>
              </Menu>
            </div>
          </div>
          <div className="my-5">
            {loading ? (
              <PeopleSkeleton />
            ) : peopleList?.length > 0 ? (
              <div className="space-y-5">
                {peopleList?.map((item, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <div className="flex items-center justify-center gap-3">
                      <img
                        src={item?.img || '/assets/images/Light_bulb.png'}
                        className="size-20 rounded-full object-cover"
                        alt="Avatar"
                      />
                      <div>
                        <h2 className="text-lg font-bold">{item?.firstName || '-'} {item?.lastName}</h2>
                        <div className="text-sm font-medium text-mediumgray flex xxs:flex-wrap gap-2 items-center my-2">
                          {/* <h6 className="text-center"> {item?.subject || "N/A"}</h6> */}
                          {/* <h6 className="text-center"> {item?.school || "N/A"}</h6> */}
                          {getRoleChip(item?.role)}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <h6
                        onClick={() => setisStatistic(true)}
                        className="regular-text underline cursor-pointer"
                      >
                        <span className="xxs:hidden"> {t("Statistics")}</span>
                        <MdOutlineGraphicEq className="xxs:block hidden" />
                      </h6>
                      <span>
                        <IoCloseOutline
                          fontSize={24}
                          className="cursor-pointer"
                          onClick={() => handleDeleteClick(item)}
                        />
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <NoDataMessage />
            )}
          </div>
        </div>
      </div>
      <div className={`${hide ? "hidden" : 'block'} md:w-full bg-white rounded-3xl p-5 relative w-[316px] lg:w-full`}>
        <img
          src="/assets/images/Helper.png"
          alt="helper"
          className="absolute -top-5 right-0"
        />
        <h2 className="text-lg font-bold">{t("whatpeople")}</h2>

        <div className="flex items-center justify-between mt-5">
          <div>
            <h4 className="regular-text ">{t("student")}</h4>
            <p className="base-text text-lightgray">{t("pq1")}</p>
          </div>
        </div>
        <div className="flex items-center justify-between mt-5">
          <div>
            <h4 className="regular-text ">{t("teacher")}</h4>
            <p className="base-text text-lightgray">{t("pq2")}</p>
          </div>
        </div>
        <h6 className="underline mt-5 regular-text cursor-pointer" onClick={toggleHide}>{t("hide")}</h6>
      </div>
      {isStatistic && (
        <StatisticModel
          isStatistic={isStatistic}
          setisStatistic={setisStatistic}
        />
      )}
      {isDelete && (
        <DeleteModel
          isDelete={isDelete}
          setIsDelete={setIsDelete}
          person={selectedPerson}
          onSuccess={handleDeleteSuccess}
        />
      )}
      {isaddpeople && (
        <AddPeopleModel
          isaddpeople={isaddpeople}
          setisAddPeople={setisAddPeople}
          fetchdata={handleDeleteSuccess}
          peopleList={peopleList}
        />
      )}
    </div>
  );
}
